/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Code_Execution_ExecuteInputs */

const es_tools_code_execution_execute = /** @type {(inputs: Tools_Code_Execution_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutando código...`)
};

const en_tools_code_execution_execute = /** @type {(inputs: Tools_Code_Execution_ExecuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executing code...`)
};

/**
* | output |
* | --- |
* | "Executing code..." |
*
* @param {Tools_Code_Execution_ExecuteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_code_execution_execute = /** @type {((inputs?: Tools_Code_Execution_ExecuteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Code_Execution_ExecuteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_code_execution_execute(inputs)
	return en_tools_code_execution_execute(inputs)
});
export { tools_code_execution_execute as "tools.code_execution.execute" }